module.exports = __webpack_public_path__ + "assets/img/goodPrize.c8fdfda9.png";